var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkingStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.69,7.69,7.31,12h0L3,16.34a3.24,3.24,0,0,0-1,2.35A3.35,3.35,0,0,0,5.36,22a3.38,3.38,0,0,0,2.38-1l4.38-4.33h0l4.35-4.31a3.26,3.26,0,0,0,1-2.36,3.34,3.34,0,0,0-1-2.34A3.4,3.4,0,0,0,11.69,7.69Zm-1,7.54L6.28,19.55a1.31,1.31,0,0,1-1.83,0,1.24,1.24,0,0,1,0-1.77L8.78,13.5h0l2.13-2.1,1.82,1.76-2.08,2.07ZM15,10.94l-.77.76L12.39,9.93l.76-.75a1.3,1.3,0,0,1,1.83,0,1.23,1.23,0,0,1,0,1.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7,4.56l-.19,1.07a.3.3,0,0,0,.43.32l1-.5,1,.5A.23.23,0,0,0,21,6h0a.25.25,0,0,0,.17-.06.27.27,0,0,0,.12-.29l-.19-1.08.78-.75a.31.31,0,0,0,.1-.3h0a.29.29,0,0,0-.25-.2l-1.07-.15-.48-1a.3.3,0,0,0-.4-.14.32.32,0,0,0-.14.14l-.48,1-1.08.16a.32.32,0,0,0-.24.21.29.29,0,0,0,.08.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.73,13.86l-1.07-.16-.48-1a.3.3,0,0,0-.4-.14.32.32,0,0,0-.14.14l-.48,1-1.08.16a.29.29,0,0,0-.24.2.3.3,0,0,0,.08.3l.78.75-.19,1.08a.28.28,0,0,0,.12.29.29.29,0,0,0,.31,0l1-.51,1,.51a.32.32,0,0,0,.14,0h0a.31.31,0,0,0,.17-.05.28.28,0,0,0,.12-.3l-.19-1.07.78-.76a.31.31,0,0,0,.1-.3h0A.28.28,0,0,0,21.73,13.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkingStick);
export default __webpack_public_path__ + "static/media/talking-stick.87e204648a27175f4b8921833cabcab5.svg";
export { ForwardRef as ReactComponent };